<div class="container" fxLayout="column">
  <app-breadcrumb [url]="goback"></app-breadcrumb>

  <app-pln-table
    [dataSource]="responseData"
    [displayedColumns]="displayedColumns"
    [tableActions]="tableActions"
    [currentPage]="tablePagination?.page || 1"
    (paginationEmitter)="handleFilter($event)"
    (actionEmitter)="handleAction($event)"
  ></app-pln-table>

  <div
    fxLayout="row"
    fxLayout.lt-lg="column"
    fxLayoutAlign="space-between center"
    class="btn__footer__container"
  >
    <button
      mat-raised-button
      type="submit"
      color="primary"
      fxFlex="30"
      fxFlex.lt-lg="100"
      [routerLink]="['/umovme-environment/details']"
    >
      Novo Cadastro
    </button>
  </div>
</div>
